import React from 'react'
import Nav from './component/Nav'
import Intro from './component/Intro'
import Servese from './component/Servese'
import Articles from './component/Articles'
import Footer from './component/Footer'




function App() {

  return (
    <>
      < Nav />
      < Intro />
      < Servese />
      < Articles />
      < Footer />
    </>
  );
}

export default App;
